// extracted by mini-css-extract-plugin
export default {"actions":"Failed-module__actions-V3oBB3","action":"Failed-module__action-FZltoI"};